<template>
  <b-container>
    <v-card>
      <address-form :modo="'crear'" :direccion="direccion" @processAddress="addAddress"></address-form>
    </v-card>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import AddressForm from "@/components/addresses/AddressFormV2";
export default {
  name: "address-create",
  mounted() {},
  components: {
    AddressForm
  },
  data() {
    return {
      direccion: {
        AvisoEmailDestino: false,
        AvisoEmailRemitente: false,
        AvisoSmsDestino: false,
        AvisoSmsRemitente: false,
        Codigo: "",
        CodigoCliente: "",
        CodigoPostal: "",
        Corporativo: "",
        DepartamentoCliente: "",
        Direccion: "",
        Email: "",
        Id: null,
        IdCliente: null,
        IdDomicilio: null,
        IdPais: null,
        IdPoblacion: null,
        Latitud: 0,
        Longitud: 0,
        Marca: "",
        MasDatos: "",
        Movil: "",
        Nombre: "",
        Nombre2: "",
        NumeroDireccion: "",
        Observacion: "",
        PisoDireccion: "",
        Poblacion: "",
        Pointer: "",
        Referencia: "",
        Telefono: "",
        TipoDireccion: "c/",
        Pais: "ESPAÑA",
        Nif: ""
      }
    };
  },
  methods: {
    ...mapActions({
      createAddress: "addresses/addAddress"
    }),
    addAddress(address) {
      this.createAddress(address).then(() => {
        this.$router.push("/direcciones");
      });
    }
  }
};
</script>
